import { render } from "./RecentComments.vue?vue&type=template&id=9d565e8c&scoped=true"
import script from "./RecentComments.vue?vue&type=script&lang=js"
export * from "./RecentComments.vue?vue&type=script&lang=js"

import "./RecentComments.vue?vue&type=style&index=0&id=9d565e8c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d565e8c"]])

export default __exports__